export SegmentDetail from './SegmentDetailRenderer';



// WEBPACK FOOTER //
// /src/components/Segments/index.js